import { render, staticRenderFns } from "./bettwasche.vue?vue&type=template&id=75c54d1d&"
import script from "./bettwasche.vue?vue&type=script&lang=js&"
export * from "./bettwasche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c54d1d')) {
      api.createRecord('75c54d1d', component.options)
    } else {
      api.reload('75c54d1d', component.options)
    }
    module.hot.accept("./bettwasche.vue?vue&type=template&id=75c54d1d&", function () {
      api.rerender('75c54d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o2TaOdLCZXTj/JS/comp/bettwasche.vue"
export default component.exports